import CheckboxComp from "themes/elements/Checkbox";
import ModalComp from "themes/elements/Modal";
import TextAreaComp from "themes/elements/TextArea";
import ModalFooter from "../modalFooter";

function RejectNews({
  isLoading,
  formData,
  setFormData,
  open,
  setOpen,
  onSubmit,
}) {
  return (
    <ModalComp
      title="Reject this news article?"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setOpen(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={isLoading}
          handleSecondaryBtn={() => {
            onSubmit();
          }}
          secondaryBtnText="Submit"
        />
      }
      open={open}
      setOpen={setOpen}
    >
      <div className="flex flex-column gap-4">
        <TextAreaComp
          maxValue={200}
          value={formData.remark}
          onChange={(e) => {
            setFormData((prev) => ({
              ...prev,
              remark: e.target.value,
            }));
          }}
          label={
            <>
              Reason for Rejection
              <span className="text-gray ml-1">(Optional)</span>
            </>
          }
          placeholder="Enter a clear and concise reason for rejecting this news article..."
        />
        <CheckboxComp
          isChecked={formData.resubmission_flg}
          onChange={(value) => {
            setFormData((prev) => ({
              ...prev,
              resubmission_flg: value,
            }));
          }}
          label="Allow resubmission"
        />
      </div>
    </ModalComp>
  );
}

export default RejectNews;
